import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer role="contentinfo" className="border-t border-border bg-card py-16 px-6">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img 
              src="/logo.png" 
              alt="Brace e Sapori Store" 
              className="mb-4 h-12 w-auto object-contain"
              width="120"
              height="48"
              loading="lazy"
            />
            <p className="mb-6 max-w-sm text-muted-foreground">
              Acquista online costate di alta qualità e prodotti tipici pugliesi.
              Spedizione in tutta Italia.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/braceesapori/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-border transition-colors hover:border-primary hover:text-primary"
                aria-label="Visita il nostro profilo Instagram"
              >
                <Instagram className="h-5 w-5" aria-hidden="true" />
              </a>
              <a
                href="https://www.facebook.com/bracesaporibraceria/?locale=it_IT"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-border transition-colors hover:border-primary hover:text-primary"
                aria-label="Visita la nostra pagina Facebook"
              >
                <Facebook className="h-5 w-5" aria-hidden="true" />
              </a>
              <a
                href="https://www.tiktok.com/@bracesapori"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-border transition-colors hover:border-primary hover:text-primary"
                aria-label="Visita il nostro profilo TikTok"
              >
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-6 text-sm font-semibold uppercase tracking-wider text-primary">
              Contatti
            </h4>
            <address className="space-y-4 text-muted-foreground not-italic">
              <div className="flex items-start gap-3">
                <MapPin className="mt-1 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
                <span>Via P. B. Moscatelli, 8<br />74027 San Giorgio Ionico (TA)</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
                <a href="tel:+393472916493" className="hover:text-foreground transition-colors" aria-label="Chiama al numero 347 291 6493">
                  347 291 6493
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
                <a href="mailto:braceesapori@yahoo.com" className="hover:text-foreground transition-colors" aria-label="Invia email a braceesapori@yahoo.com">
                  braceesapori@yahoo.com
                </a>
              </div>
            </address>
          </div>

          {/* Hours */}
          <div>
            <h4 className="mb-6 text-sm font-semibold uppercase tracking-wider text-primary">
              Orari
            </h4>
            <ul className="space-y-2 text-muted-foreground">
              <li className="flex justify-between">
                <span>Sabato</span>
                <span>17:00 - 00:00</span>
              </li>
              <li className="flex justify-between">
                <span>Domenica</span>
                <span>09:00 - 00:00</span>
              </li>
              <li className="flex justify-between">
                <span>Lunedì</span>
                <span>10:30 - 00:30</span>
              </li>
              <li className="flex justify-between">
                <span>Martedì</span>
                <span>17:00 - 00:00</span>
              </li>
              <li className="flex justify-between">
                <span>Mercoledì</span>
                <span className="text-primary">Chiuso</span>
              </li>
              <li className="flex justify-between">
                <span>Giovedì</span>
                <span>17:00 - 00:00</span>
              </li>
              <li className="flex justify-between">
                <span>Venerdì</span>
                <span>17:00 - 00:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <div className="flex flex-col items-center gap-4 md:flex-row md:justify-between">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Brace & Sapori. Tutti i diritti riservati.
            </p>
            <nav aria-label="Link legali" className="flex flex-wrap items-center justify-center gap-4 text-sm text-muted-foreground">
              <a href="/privacy" className="hover:text-foreground transition-colors" aria-label="Leggi la privacy policy">
                Privacy Policy
              </a>
              <span className="text-border" aria-hidden="true">|</span>
              <a href="/cookie-policy" className="hover:text-foreground transition-colors" aria-label="Leggi la cookie policy">
                Cookie Policy
              </a>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};
